// extracted by mini-css-extract-plugin
module.exports = {"a":"_3x-xTqMrYEvjiN4qgxhzEj","card":"_3U4KGFoKeUh9KfndjQuxT-","row":"_3_n6RNHgXXuN4vNgKyd4BQ","col":"_1u8FXGdE-WyXjKayYlVU6t","space":"_ix4WJIQ386x07ENMKe6l"};